import React from "react";
import CookieService from "../service/cookieService";
import {Navigate} from "react-router";

const ProtectedRoute = ({component: Component, ...rest}) => {
  const cookieService = CookieService.getService();
  const isTokenAvailable = cookieService.isTokenAvailable();

  if (!isTokenAvailable) {
    return <Navigate to="/auth/login" replace />;
  }

  return <Component {...rest} />;
};

export default ProtectedRoute;
